import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getActivityLog } from "../../../redux/slices/ActivityLogSlice";
import ActivityLogTimelineView from "../../../components/ActivityLog/ActivityLogTimelineView";

const EnquiryActivityLog = ({ orgId, dealCategoryId }) => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const limit = 20;

  const { logs = [], loading = false, totalRecords = 0 } = useSelector((state) => state?.activityLog) || {};

  useEffect(() => {
    if (orgId) {
      dispatch(getActivityLog({ module: "ENQUIRY", entityId: orgId, page, limit, dealCategoryId }));
    }
  }, [dispatch, orgId, page, dealCategoryId]);

  const getActionConfig = (action) => {
    switch (action) {
      case "NEW_ENQUIRY":
      case "ENQUIRY_CREATED": return { label: "Onboarding", color: "#e6ffed", textColor: "#22c55e" };
      case "APPROVE_ENQUIRY":
      case "ENQUIRY_APPROVED": return { label: "Approved", color: "#e6ffed", textColor: "#22c55e" };
      case "REJECT_ENQUIRY":
      case "ENQUIRY_REJECTED": return { label: "Rejected", color: "#fff1f0", textColor: "#f5222d" };
      case "COMPLETE_KYC": return { label: "KYC Completed", color: "#e6ffed", textColor: "#22c55e" };
      case "REVIEW_KYC": return { label: "KYC Reviewed", color: "#e6f7ff", textColor: "#1890ff" };
      case "QUESTIONNAIRE_SENT": return { label: "Questionnaire Sent", color: "#e6f7ff", textColor: "#1890ff" };
      case "QUESTIONNAIRE_RESPONSE": return { label: "Questionnaire Response", color: "#e6f7ff", textColor: "#1890ff" };
      case "ACTIVATE_USER": return { label: "User Activated", color: "#e6ffed", textColor: "#22c55e" };
      case "REJECT_USER": return { label: "User Rejected", color: "#fff1f0", textColor: "#f5222d" };
      case "REOPEN_ENQUIRY": return { label: "Enquiry Reopened", color: "#fffbe6", textColor: "#d4b106" };
      case "CREDIT_LIMIT_CREATED":
      case "CREDIT_LIMIT_ASSIGNED": return { label: "Credit Limit Assigned", color: "#fff2e8", textColor: "#fa541c" };
      case "CREDIT_LIMIT_APPROVED": return { label: "Credit Limit Approved", color: "#e6ffed", textColor: "#22c55e" };
      case "CREDIT_LIMIT_REJECTED": return { label: "Limit Rejected", color: "#fff1f0", textColor: "#f5222d" };
      case "CREDIT_LIMIT_UPDATED":
      case "CREDIT_LIMIT_ENHANCED": return { label: "Limit Enhanced", color: "#e6f7ff", textColor: "#1890ff" };
      default: return { label: action.replace(/_/g, " "), color: "#e6f7ff", textColor: "#1890ff" };
    }
  };

  const formatDesc = (log) => {
    const role = log.performedByRole || "System";
    const name = log.performedByName || "Unknown User";
    const actionConfig = getActionConfig(log.action);
    const busName = log.payload?.busName;
    const busStr = busName ? ` for <strong>"${busName}"</strong>` : "";
    return `<strong>${name}</strong> (${role}) <strong>PERFORMED ${actionConfig.label.toUpperCase()}</strong>${busStr}`;
  };

  const filterPayloadEntries = (payload) => {
    if (!payload || typeof payload !== "object") return [];
    return Object.entries(payload).filter(([key]) => key !== "entityTypeId" && key !== "entityType" && key !== "businessTypeId" && key !== "businessType");
  };

  const formatPayloadKey = (key) => {
    const displayKey = key === "dealCategoryId" ? "dealCategoryName" : key;
    return displayKey.replace(/([A-Z])/g, ' $1').trim();
  };

  const formatPayloadValue = (key, value) => {
    return typeof value === 'object' ? JSON.stringify(value) : String(value ?? "");
  };

  return (
    <ActivityLogTimelineView
      title="Business Onboarding Activity"
      totalRecords={totalRecords}
      loading={loading}
      logs={logs}
      page={page}
      setPage={setPage}
      limit={limit}
      getActionConfig={getActionConfig}
      formatDesc={formatDesc}
      filterPayloadEntries={filterPayloadEntries}
      formatPayloadKey={formatPayloadKey}
      formatPayloadValue={formatPayloadValue}
    />
  );
};

export default EnquiryActivityLog;
